module.exports = __webpack_public_path__ + "img/Patch23-3.83b22019.webp";